var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 0.90625L13.4688 2.53125C12.0625 1.125 10.125 0.25 8 0.25C3.71875 0.25 0.21875 3.75 0.25 8.03125C0.25 12.3125 3.71875 15.75 8 15.75C9.96875 15.75 11.8125 15 13.1875 13.7812C13.3438 13.625 13.3438 13.375 13.1875 13.2188L12.5625 12.5938C12.4375 12.4688 12.2188 12.4688 12.0625 12.5938C10.9688 13.5625 9.5625 14.125 8 14.125C4.59375 14.125 1.875 11.4062 1.875 8C1.875 4.625 4.59375 1.875 8 1.875C9.6875 1.875 11.2188 2.5625 12.3125 3.6875L10.625 5.375C10.375 5.625 10.5625 6 10.875 6H15.375C15.5625 6 15.75 5.84375 15.75 5.625V1.15625C15.75 0.84375 15.3438 0.65625 15.0938 0.90625Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.38f5f13d.svg";
export { ForwardRef as ReactComponent };